module.exports = __webpack_public_path__ + "static/media/panis_26.8ce54258.jpg";